export const LOADER_STATUS = "boilerplate/Notices/Notice/LOADER_STATUS";
export const GSTIN_LIST = "boilerplate/Notices/Notice/GSTIN_LIST";
export const SELECTED_GSTIN = "boilerplate/Notices/Notice/SELECTED_GSTIN";
export const SELECTED_DATE = "boilerplate/Notices/Notice/SELECTED_DATE";
export const NOTICE_TABLE_DATA = "boilerplate/Notices/Notice/NOTICE_TABLE_DATA";
export const TOTAL_PAGES = "boilerplate/Notices/Notice/TOTAL_PAGES";
export const TOTAL_PAGES_HISTORY =
  "boilerplate/Notices/Notice/TOTAL_PAGES_HISTORY";
export const SCHEDULER_TABLE_DATA =
  "boilerplate/Notices/Notice/SCHEDULER_TABLE_DATA";
export const SEARCH = "boilerplate/Notices/Notice/SEARCH";
export const HISTORY_DATA = "boilerplate/Notices/Notice/HISTORY_DATA";
export const ENTITY_LIST = "boilerplate/Notices/Notice/ENTITY_LIST";
export const SELECTED_ENTITY = "boilerplate/Notices/Notice/SELECTED_ENTITY";
export const PROFILE_DATA = "boilerplate/Notices/Notice/PROFILE_DATA";
export const REF_IDS_LIST = "boilerplate/Notices/Notice/REF_IDS_LIST";
export const NOTICE_TYPE_LIST = "boilerplate/Notices/Notice/NOTICE_TYPE_LIST";
export const SELECTED = "boilerplate/Notices/Notice/SELECTED";
export const SELECTED_ROW = "boilerplate/Notices/Notice/SELECTED_ROW";
export const SELECTED_FROM_PERIOD =
  "boilerplate/Notices/Notice/SELECTED_FROM_PERIOD";
export const SELECTED_TO_PERIOD =
  "boilerplate/Notices/Notice/SELECTED_TO_PERIOD";
export const SELECTED_ISSUE_DATE =
  "boilerplate/Notices/Notice/SELECTED_ISSUE_DATE";
export const SELECTED_DUE_DATE = "boilerplate/Notices/Notice/SELECTED_DUE_DATE";
export const NOTICE_TYPE_CODE_FILTER_LIST =
  "boilerplate/Notices/Notice/NOTICE_TYPE_CODE_FILTER_LIST";
export const REFERENCE_ID_FILTER_LIST =
  "boilerplate/Notices/Notice/REFERENCE_ID_FILTER_LIST";

export const headerColumns = [
  {
    value: "Scheduler",
    id: 1,
  },
  {
    value: "Scheduler History",
    id: 2,
  },
];
